import React, { useState } from "react";
import Pane from "components/modals/Pane";
import {ORSMasterListing} from "components/globals/ORSMasterListing"

const FollowersAndFollowing = ({user}) => {

	const [followersPane, setFollowersPane] = useState(false);
	const [followingPane, setFollowingPane] = useState(false);


	const openFollowersPane = () => {
		setFollowersPane(true);
	}

	const openFollowingPane = () => {
		setFollowingPane(true);
	}
	
	const closeFollowersPane = () => {
		setFollowersPane(false);
	}

	const closeFollowingPane = () => {
		setFollowingPane(false);
	}

	const followersList = { 
		params: {
			elementId: "recentUsers", 
			headingTitle: "Followers",
			headingButtonUrl: "",
			headingButtonText: "",
			apiPath: `users/followers/${user.username}`,
			omit: "none",
			limit: "6",
			type: "user", 
			pagination: true,
		},
		displayOptions: {
			layout: "row",
			yoursBadge: true,
			typeBadge: true,
			categoryBadge: false,
			userBadge: true,
			carBadge: true,
			carDetails: true,
			dateDetails: true,
			rowColumns: false,
			mobileCarousel: false,
			likes: true,
		}
	}

	const followingList = { 
		params: {
			elementId: "recentUsers", 
			headingTitle: "Following",
			headingButtonUrl: "",
			headingButtonText: "",
			apiPath: `users/following/${user.username}`,
			omit: "none",
			limit: "6",
			type: "user", 
			pagination: true,
		},
		displayOptions: {
			layout: "row",
			yoursBadge: true,
			typeBadge: true,
			categoryBadge: false,
			userBadge: true,
			carBadge: true,
			carDetails: true,
			dateDetails: true,
			rowColumns: false,
			mobileCarousel: false,
			likes: true,
		}
	}
	
	return (
		<>
			<div className="my-3 flex items-center">
				<LargeButton onClick={openFollowersPane} label="Followers" count={user?.followersCount} />
				<LargeButton onClick={openFollowingPane} label="Following" count={user?.followingCount} />
			</div>

			<Pane visible={followersPane} onClose={closeFollowersPane}>
        <div className="relative mt-6">
          <ORSMasterListing params={followersList.params} displayOptions={followersList.displayOptions} />
        </div>
      </Pane>

			<Pane visible={followingPane} onClose={closeFollowingPane}>
        <div className="relative mt-6">
					<ORSMasterListing params={followingList.params} displayOptions={followingList.displayOptions} />
        </div>
      </Pane>
		</>
	);
};

const LargeButton = ({onClick, label, count}) => {
	return (
		<div 
			onClick={(e) => {
				e.preventDefault();
				onClick();
			}}
			className="bg-white mr-2 mb-2 p-2 text-center rounded-lg hover:bg-brg hover:text-white transition cursor-pointer">
			<div className=" uppercase text-[10px] mb-1">{label}</div>
			<div className="text-[30px]  pt-2 pb-3">{count}</div>
		</div>
	)
}

export default FollowersAndFollowing;
